import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table15Data = { [key: string]: Table15Row };

export interface ITable15Props {
  data: Table15Data;
}

interface ITable15State {
}

export interface Table15Row {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Female",
  "Male",
  "Not Stated",
  "Unknown (Not Stated)",
  "TOTALS",
];

export default class Table15Summary extends React.Component<ITable15Props, ITable15State> {
  constructor(props: ITable15Props) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: '50%' }} />
              <col span={6} style={{ width: '8.3%' }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">15</span>
                    <span className="header-text">SEX OF DRIVER</span>
                  </div>
                </th>
                <th rowSpan={2}>TOTAL</th>
                <th rowSpan={2}>FATAL</th>
                <th colSpan={3}>INJURY</th>
                <th rowSpan={2}>PDO **</th>
              </tr>
              <tr>
                <th>A*</th>
                <th>B*</th>
                <th>C*</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].total}</td>
                  <td className="numberTotals">{this.props.data[key].fatal}</td>
                  <td className="numberTotals">{this.props.data[key].injuryA}</td>
                  <td className="numberTotals">{this.props.data[key].injuryB}</td>
                  <td className="numberTotals">{this.props.data[key].injuryC}</td>
                  <td className="numberTotals">{this.props.data[key].pdo}</td>
                </tr>
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </React.Fragment>
    );
  }
}
